import { TextAa } from '@phosphor-icons/react';

export default TextAa;
